import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServiceService } from '../../services/api-service.service';
import { environment } from '../../../environments/environment.development';

import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrl: './order-details.component.scss'
})
export class OrderDetailsComponent {
  orderids: any;
  orderListDetailsImageUrl = environment.ImageBaseUrl;
  ordesDeails: any;
  constructor(private router:Router, private api:ApiServiceService ,private activeRouter:ActivatedRoute ,public Loader:LoaderService){
  this.activeRouter.params.subscribe((orderId : any)=>{
      const id = orderId['id'];
      this.getOrderById(id);
      // this.generateInvoice(id);
    })
  }

getOrderById(id: any){
    this.api.getOrderById(id).subscribe((res: any)=>{
      this.ordesDeails = res.data;
      this.orderids = res.orderDetails;
    },(error)=>{
      // console.log('error', error)
    })
}


generateInvoice(orderId: string) {
  this.Loader.showLoader();
  this.api.generateSingleInvoice(orderId).subscribe({
    next: (res) => {
       this.Loader.hideLoader();
      if (res.success && res.downloadUrl) {
        window.open(res.downloadUrl, '_blank'); // Open invoice in new tab
      } else {
        console.error('Invoice generation failed:', res.message);
      }
//       const newTab = window.open(res.downloadUrl, '_blank');
// if (!newTab) {
//   alert('Popup blocked. Please allow popups for this site.');
// }

    },
    error: (err) => {
      console.error('API Error:', err);
    }
  });
}


getTotalAmount(): number {
  if (!this.ordesDeails?.items) return 0;

  return this.ordesDeails.items.reduce((total: number, item: any) => {
    return total + (item.price * item.quantity);
  }, 0);
}


}
